enum JobOpType {
  RANGE = 'range',
  BOOLEAN = 'boolean',
  RANGE_BOOLEAN = 'range-boolean',
  OPTIONS = 'options',
  UNKNOWN = 'unknown',
}

export default JobOpType;
